import { eventBus } from '@atc/cai-event-bus';
import debugWallet from './debugWallet.js';
import { UDS_SDP_ONTRACK_COMPLETED } from '../constants/events.js';
async function buildHooksObject(hooks, offer, selectedCriteria) {
  const {
    onDRLoaded,
    onDRTrack,
    onDRHidden
  } = hooks || {};
  const handleOnDRLoaded = error => {
    if (error) {
      if (error?.errorType === 'activEngageId_process_failed') {
        // eslint-disable-next-line no-console
        console.warn('ActivEngageId process failed');
        // temporarily surpress error due to lead form being triggered by false ActivEngageId failure
        // TODO: remove when ActivEngageId issue is fixed
        return;
      }
      const errorMessage = error?.error?.response?.data?.error?.message || 'Unknown error';
      // eslint-disable-next-line no-console
      console.warn('Error loading the DR Overlay: ', errorMessage);
      if (window?.newrelic) {
        window.newrelic.addPageAction('ThirdPartyError', {
          thirdPartyName: 'Accelerate',
          component: 'UDS',
          message: 'SDP Error: ' + errorMessage,
          url: window.location.href,
          error: error.errorType
        });
      }
    }
    if (onDRLoaded) onDRLoaded(error, offer);
  };
  const handleOnDRTrack = (name, action, data) => {
    const payload = {
      name,
      action,
      data
    };
    eventBus.emit(UDS_SDP_ONTRACK_COMPLETED, payload);
    debugWallet('UDS', 'SDP OnTrack Completed', payload);
    if (onDRTrack) onDRTrack(name, action, data, selectedCriteria);
  };
  const handleOnDRHidden = () => {
    // eslint-disable-next-line no-console
    console.log('DR Overlay was closed.');
    if (onDRHidden) onDRHidden();
  };
  return {
    onTrack: handleOnDRTrack,
    onLoadedFunction: handleOnDRLoaded,
    onHidingFunction: handleOnDRHidden
  };
}
export { buildHooksObject as default };
